import React from "react"
import {Link, Typography}  from "@material-ui/core"
import { Link as RouterLink }from "react-router-dom";


const Copyright = () => {
	return(
		<Typography align="center" variant="subtitle2">
		{'© '}
        <Link color="inherit" component={RouterLink} to="/">
          Betastore
        </Link>{' '}
        {new Date().getFullYear()}
		</Typography>
	)
}
export default Copyright;